/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OnboardingEmail/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function OnboardingEmail({
  children,
  viewPath = "/DesignSystem/Images/OnboardingEmail",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 1031,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 760
  
}) {
  return (<React.Fragment
>
<img
  data-testid="OnboardingEmail.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Z28snYm': alignSelf,'--bc-2-Z28snYm': backgroundColor,'--bblr-3-Z28snYm': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z28snYm': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z28snYm': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z28snYm': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z28snYm': typeof height === 'number' ? `${height}px` : height,'--mb-8-Z28snYm': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Z28snYm': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z28snYm': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Z28snYm': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Z28snYm': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}